import React from 'react';

import Modal from './Modal';

import globalBoostrapStyle from '../../../assets/global-style/bootstrap.module.css';
import styleButtomCustom from '../../../assets/style/css/style_buttom.module.css';
import cx from 'classnames';


const GenericModal = (props) => (
    <Modal visible={props.visible}
           onClickBackdrop={props.closeModal}
           dialogStyle={props.dialogStyle != null ? props.dialogStyle : null}>

        <div className="modal-header">

            {props.title &&
                typeof props.title === 'object' ? (
                    <div>
                        <h5 className="modal-title">{props.title.title}</h5>
                        <p className="m-0">{props.title.giorno} -&gt;  {props.title.oraInizio} - {props.title.oraFine}</p>
                    </div>
                ) : <h5 className="modal-title">{props.title}</h5>
            }

            <button style={{outline: 'none'}}
                    className={cx(globalBoostrapStyle['float-right'], globalBoostrapStyle['p-1'], styleButtomCustom.closeCustom)}
                    onClick={props.closeModal}>
                &times;
            </button>

        </div>

        <div className="modal-body">
            {props.children[0]}
        </div>

        {
            props.children.length > 1 && (
                <div className="modal-footer justify-content-center">
                    {props.children[1]}
                </div>
            )
        }

    </Modal>
)

export default GenericModal;

